import get from 'lodash/get'
import { Controller, useFormContext } from 'react-hook-form'

import { Component } from './Component'
import { mask } from '@utils/masks'
import { normalizeCurrencyInput } from '@utils/masks/currencyMask'

import type { InputProps } from './types'

export const Input = ({
  name,
  label,
  required,
  error,
  hasController = true,
  maskType,
  forceNegative = false,
  maxDigits,
  onChange,
  ...rest
}: InputProps) => {
  if (hasController) {
    const { control } = useFormContext()

    return (
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => {
          const rawValue = field.value ?? ''
          const displayValue = mask({ type: maskType, value: rawValue })
          const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const next = e?.target?.value ?? ''
            if (maskType === 'currency' || maskType === 'decimal') {
              const digits = next.replace(/\D/g, '')
              if (maxDigits && digits.length > maxDigits) return
              const isNegative = forceNegative ? digits.length > 0 : next.includes('-')
              const valueToMask = isNegative ? `-${digits}` : digits
              const normalized = mask({ type: maskType, value: valueToMask })
              field.onChange(normalized)
            } else {
              field.onChange(next)
            }
          }
          return (
            <Component
              name={name}
              label={label}
              required={required}
              error={get(errors, name)?.message as string | undefined}
              value={displayValue}
              onChange={handleChange}
              onBlur={field.onBlur}
              {...rest}
            />
          )
        }}
      />
    )
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (maskType === 'currency') {
      e.target.value = normalizeCurrencyInput(e.target.value, forceNegative)
    }

    onChange?.(e)
  }

  return <Component name={name} label={label} required={required} error={error} onChange={handleChange} {...rest} />
}
